module.exports = __webpack_public_path__ + "img/xl_gd.3d3c8e0c.png";